export default "__VITE_ASSET__CMK2ED4Z__"